import React, { useState } from "react";

import Dialog from "./Dialog";
import FormContainer from "../Form/FormContainer";
import { useApi } from "../../../../api";
import { setFieldErrorsFromResponse } from "../../../../utils/formErrors";
import useI18nSnackbar from "../../../../hooks/useI18nSnackbar";
import ConfirmationDialog from "../../../../elements/ConfirmationDialog";
import { SaveButton } from "../../../../elements/Button";
import I18nText from "../../../../elements/I18nText";

const BulkEditContainer = ({ user, deviceIds, onClose }) => {
  const api = useApi();
  const { enqueueSnackbar } = useI18nSnackbar();
  const [pendingSubmit, setPendingSubmit] = useState(null);
  const [isSubmitting, setSubmitting] = useState(false);

  const handleSubmit = (values, formikBag) => {
    setPendingSubmit({ values, formikBag });
  };

  const handleCancelConfirm = () => {
    pendingSubmit.formikBag.setSubmitting(false);
    setPendingSubmit(null);
  };

  const handleConfirm = () => {
    const { values, formikBag } = pendingSubmit;
    const permissions = Object.keys(values.permissions).filter(
      permission => values.permissions[permission]
    );

    setSubmitting(true);

    api
      .put(`/v2/users/${user.id}/aces/bulk`, { deviceIds, permissions })
      .then(() => {
        enqueueSnackbar("users.responses.updated", { variant: "success" });
        setSubmitting(false);
        onClose(true);
      })
      .catch(e => {
        setSubmitting(false);
        formikBag.setSubmitting(false);
        setPendingSubmit(null);

        if (e.response) {
          setFieldErrorsFromResponse(e.response, formikBag.setFieldError);
        }
      });
  };

  return (
    <>
      <Dialog onClose={onClose}>
        <FormContainer
          userId={user.id}
          username={user.username}
          deviceId={
            <I18nText values={{ count: deviceIds.length }}>
              users.access.bulkEdit.deviceCount
            </I18nText>
          }
          titleKey="users.access.bulkEdit.selectedDevices"
          existingPermissions={[]}
          onClose={onClose}
          onSubmit={handleSubmit}
        />
      </Dialog>
      {pendingSubmit && (
        <ConfirmationDialog
          isSubmitting={isSubmitting}
          onCancel={handleCancelConfirm}
          ConfirmButton={
            <SaveButton disabled={isSubmitting} onClick={handleConfirm} />
          }
        >
          <I18nText values={{ count: deviceIds.length }}>
            users.access.bulkEdit.confirmation
          </I18nText>
        </ConfirmationDialog>
      )}
    </>
  );
};

export default BulkEditContainer;
